module.exports = __webpack_public_path__ + "media/images/vector/InstagramLogo-3f3808db4c85eb0ad202ede05bd821fc.svg";